import { Paper, styled } from "@mui/material";


const StyledPaper = styled(Paper)(() => ({
    borderRadius: 12,
}));

export default StyledPaper;
